import classNames from "classnames";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import Table from "components/DesignSystem/Table/V2/Table";
import { ColumnDef } from "react-table-8.10.7";
import { RagStatus } from "./utils/csOverview";

const RAG_TEXT_CLASS: Record<RagStatus, string> = {
  green: "t-text-dark_green-70",
  amber: "t-text-orange-70",
  red: "t-text-red-70",
};

const RAG_DOT_CLASS: Record<RagStatus, string> = {
  green: "t-bg-dark_green-70",
  amber: "t-bg-orange-70",
  red: "t-bg-red-70",
};

type StatusDotProps = { status: RagStatus };

export const StatusDot = ({ status }: StatusDotProps) => (
  <span
    className={classNames(
      "t-inline-block t-rounded-full t-h-2 t-w-2 t-shrink-0",
      RAG_DOT_CLASS[status]
    )}
  />
);

type StatusPillProps = { label: string; status: RagStatus };

export const StatusPill = ({ label, status }: StatusPillProps) => {
  const tagTypeMap: Record<RagStatus, "green" | "orange" | "red"> = {
    green: "green",
    amber: "orange",
    red: "red",
  };
  return (
    <Tag tagType={tagTypeMap[status]} icon={false} size="small">
      {label}
    </Tag>
  );
};

type RatingDisplayProps = { rating: number; ragStatus: RagStatus };

export const RatingDisplay = ({ rating, ragStatus }: RatingDisplayProps) => {
  if (rating === 0) {
    return <span className="t-text-body-sm t-text-text-30">-</span>;
  }

  return (
    <span
      className={classNames(
        "t-text-body-sm t-font-bold",
        RAG_TEXT_CLASS[ragStatus]
      )}
    >
      ★ {rating.toFixed(1)}
    </span>
  );
};

type CategoryTagProps = { label: string | null };

export const CategoryTag = ({ label }: CategoryTagProps) => {
  if (!Boolean(label)) return "-";
  return (
    <Tag tagType="dark_gray" icon={false} size="small">
      {label}
    </Tag>
  );
};

type TableSkeletonRowsProps = {
  columns: ColumnDef<any, any>[];
  rows?: number;
};

export const TableSkeletonRows = ({
  columns,
  rows = 5,
}: TableSkeletonRowsProps) =>
  Array.from({ length: rows }).map((_, i) => (
    <Table.Row key={i}>
      {columns.map((_, j) => (
        <Table.Cell key={j}>
          <Skeleton className="t-h-4 t-w-full" />
        </Table.Cell>
      ))}
    </Table.Row>
  ));
